import { render, staticRenderFns } from "./OperaLabelExpressWindow.vue?vue&type=template&id=2a0bde7e&scoped=true&"
import script from "./OperaLabelExpressWindow.vue?vue&type=script&lang=js&"
export * from "./OperaLabelExpressWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaLabelExpressWindow.vue?vue&type=style&index=0&id=2a0bde7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0bde7e",
  null
  
)

export default component.exports